import { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./register-style.css";
import GenderMenu from "../../dialog/default-menu/DefaultMenuDialog";
import BirthTimeMenu from "../../dialog/default-menu/DefaultMenuDialog";
import CalenderPicker from "../../dialog/calender/calender-picker";
import ClockPicker from "../../dialog/clock/clock-picker";
import BirthplacePicker from "../../dialog/birthplace-picker/birthplace-picker";
import Menulist from "../../../constant/menulist";
import AuthService from "../../../service/auth-service";
import SiteFooter from "../../custom/site-footer/site-footer";
import useIsMobile from "../../../hooks/useIsMobile";
import ToastDialog from "../../dialog/toast/toast-dialog";

const RegisterComponent = ({ setShowServiceMenu, setShowPersonalMenu }) => {
  const [name, setName] = useState("");
  const [gender, setGender] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [birthTimeSign, setBirthTimeSign] = useState("");
  //真太陽時所需資料
  const [birthClockTime, setBirthClockTime] = useState("");
  const [birthLongitude, setBirthLongitude] = useState("");
  const [birthLatitude, setBirthLatitude] = useState("");

  //0：標準時間 / 1：真太陽時
  const [timeMode, setTimeMode] = useState("0");
  const [foucsIndex, setFoucsIndex] = useState(-1);

  const [showGenderMenu, setShowGenderMenu] = useState(false);
  const [showBirthTimeMenu, setShowBirthTimeMenu] = useState(false);
  const [showSunTimeDes, setShowSunTimeDes] = useState(false);
  const [showRegisterSuccess, setShowRegisterSuccess] = useState(false);

  //出生地選擇（用 G-1 級聯查詢；選好後自動填 lng/lat，也可下方手動微調）
  const [showBirthplacePicker, setShowBirthplacePicker] = useState(false);
  const [birthPlaceName, setBirthPlaceName] = useState("");

  //picker 選定 callback
  const handleBirthplaceSelect = ({ fullName, lat, lng }) => {
    setBirthPlaceName(fullName || "");
    if (typeof lng === "number") setBirthLongitude(String(lng));
    if (typeof lat === "number") setBirthLatitude(String(lat));
  };
  const isMobile = useIsMobile();

  let navigate = useNavigate();
  let location = useLocation();
  //來源頁路徑（state.from）：呼叫端 navigate("/register", { state: { from: "/article/ABC" } })
  //  完成註冊後優先回原頁；沒指定就 fallback 到個人命盤
  const returnTo = location.state?.from || "/personal-chart";

  //判斷註冊表單的資料是否填齊備
  const isFormComplete = Boolean(
    name.trim() &&
    gender &&
    birthDate &&
    (timeMode == "0"
      ? birthTimeSign
      : birthClockTime && birthLongitude && birthLatitude),
  );

  const GENDER_MAP = Menulist.genderMap;
  const BIRTH_TIME_MAP = Menulist.birthTimeMap;

  const handleRegister = async () => {
    //未登入返回首頁，由 nav 重新觸發登入流程
    if (!AuthService.getLoginStatus()) {
      navigate("/");
      return;
    }

    const response = await AuthService.register({
      name,
      gender,
      birthDate,
      timeMode,
      birthTimeSign,
      birthClockTime,
      birthLongitude,
      birthLatitude,
    });

    //註冊成功：先彈 toast，由 toast 的 onClose 觸發跳轉（讓使用者看到「註冊成功」）
    if (response.data.status) {
      AuthService.updateUserInfo(response.data.data);

      const userValidCode = AuthService.getUserProfile().userValidCode;

      if (userValidCode == "2") {
        setShowRegisterSuccess(true);
      }
    }
  };

  return (
    <div className="register-page">
      {!isMobile && (
        <main
          className="web-main"
          onMouseEnter={() => {
            setShowServiceMenu(false);
            setShowPersonalMenu(false);
          }}
          onClick={() => {
            setShowBirthTimeMenu(false);
            setShowGenderMenu(false);
            setShowSunTimeDes(false);
          }}
        >
          <div className="input-background">
            <img
              src={`/images/bg-input-info.png`}
              loading="lazy"
              alt="圖片 1"
            />
          </div>

          <p className="title">開始探索元辰雲閣</p>
          <p className="sub-title">
            請輸入您的個人資訊，資料越詳細結果越準確哦！
          </p>

          {/*註冊資訊輸入卡*/}
          <div className="user-card">
            {/*你的姓名*/}
            <div
              className={`item-info ${foucsIndex == 0 ? "foucs" : "non-focus"}`}
            >
              <p>你的姓名</p>
              <input
                className="input-block"
                placeholder="請輸入姓名"
                maxLength={10}
                value={name}
                onChange={(e) => setName(e.target.value)}
                onFocus={() => {
                  setFoucsIndex(0);
                }}
              ></input>
            </div>

            {/*性別選單*/}
            <div
              className={`item-info menu ${foucsIndex == 1 ? "foucs" : "non-focus"}`}
              onClick={(e) => {
                e.stopPropagation();
                setShowBirthTimeMenu(false);
                setShowSunTimeDes(false);
                setShowGenderMenu(!showGenderMenu);
              }}
            >
              <p>性別</p>
              <input
                className="input-block"
                placeholder="請選擇生理性別"
                readOnly
                value={GENDER_MAP[gender]}
                onFocus={() => {
                  setFoucsIndex(1);
                }}
              ></input>
              <img src="../images/ic-brown-down.png"></img>
              {showGenderMenu && (
                <div className="float-menu">
                  <GenderMenu
                    dataMap={GENDER_MAP}
                    onSuccess={(gender) => {
                      setGender(gender);
                    }}
                    onClose={() => setShowGenderMenu(false)}
                  ></GenderMenu>
                </div>
              )}
            </div>

            {/*出生日期日曆*/}
            <div
              className={`item-info  ${foucsIndex == 2 ? "foucs" : "non-focus"}`}
            >
              <p>出生日期</p>
              <div className="calender">
                <CalenderPicker
                  birthDate={birthDate}
                  setBirthDate={setBirthDate}
                  onFocus={() => {
                    setFoucsIndex(2);
                  }}
                />
              </div>
              <img src="../images/ic-brown-down.png"></img>
            </div>

            {/*標準時間／太陽時選擇*/}
            <div className="select-radio">
              <div className="option">
                <input
                  type="radio"
                  name="method"
                  id="standard"
                  value="standard"
                  checked={timeMode === "0"}
                  onChange={() => setTimeMode("0")}
                />
                <label htmlFor="standard">標準時間</label>
              </div>

              <div className="option suntime">
                <input
                  type="radio"
                  name="method"
                  id="sun"
                  value="sun"
                  checked={timeMode === "1"}
                  onChange={() => setTimeMode("1")}
                />
                <label htmlFor="sun">真太陽時</label>

                <img
                  onClick={(e) => {
                    setShowGenderMenu(false);
                    setShowBirthTimeMenu(false);
                    setShowSunTimeDes(true);
                    e.stopPropagation();
                  }}
                  src="../images/ic-description.png"
                ></img>

                <div className="suntime-tag">
                  {showSunTimeDes && (
                    <div
                      className="suntime-des"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <p className="title">什麼是真太陽時？</p>
                      <p className="des">
                        真太陽時（True Solar Time）是以天文學算式計算太陽
                        相對地平線的位置的時間，反映某地實際日照狀況。當
                        太陽位於當地子午線上時，即為「真正的中午」。它不同
                        於人為劃分的標準時間，因為地球自轉與公轉的影響，真
                        太陽時會因地點與日期而有所變化，真太陽時則能根據
                        個人的出生經緯度，精確地還原當地的實際時間。
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/*出生時辰-標準時間選單*/}
            {timeMode == "0" && (
              <div
                className={`item-info menu ${foucsIndex == 3 ? "foucs" : "non-focus"}`}
                onClick={(e) => {
                  setShowSunTimeDes(false);
                  setShowGenderMenu(false);
                  setShowBirthTimeMenu(!showBirthTimeMenu);
                  e.stopPropagation();
                }}
              >
                <p>出生時辰</p>
                <input
                  className="input-block"
                  placeholder="早子時 00:00-00:59"
                  value={BIRTH_TIME_MAP[birthTimeSign]}
                  readOnly
                  onFocus={() => {
                    setFoucsIndex(3);
                  }}
                ></input>
                <img src="../images/ic-brown-down.png"></img>
                {showBirthTimeMenu && (
                  <div className="float-menu">
                    <BirthTimeMenu
                      dataMap={BIRTH_TIME_MAP}
                      onSuccess={(timeSign) => {
                        setBirthTimeSign(timeSign);
                      }}
                      onClose={() => setShowBirthTimeMenu(false)}
                    ></BirthTimeMenu>
                  </div>
                )}
              </div>
            )}

            {/*出生時辰-真太陽時選單*/}
            <div>
              {timeMode == "1" && (
                <div
                  className={`item-info menu ${foucsIndex == 4 ? "foucs" : "non-focus"}`}
                  onClick={(e) => {
                    setShowSunTimeDes(false);
                    setShowGenderMenu(false);
                    e.stopPropagation();
                  }}
                >
                  <p>出生時辰</p>

                  <ClockPicker
                    clockTime={birthClockTime}
                    setClockTime={setBirthClockTime}
                    onFocus={() => {
                      setFoucsIndex(4);
                    }}
                  />

                  <img src="../images/ic-brown-down.png"></img>
                </div>
              )}

              {/*快速選擇出生地：自己一格，跟出生時辰同層；選好自動填入下方經緯度*/}
              {timeMode == "1" && (
                <div
                  className={`item-info menu ${foucsIndex == 7 ? "foucs" : "non-focus"}`}
                  onClick={(e) => {
                    setShowSunTimeDes(false);
                    setShowGenderMenu(false);
                    setFoucsIndex(7);
                    setShowBirthplacePicker(true);
                    e.stopPropagation();
                  }}
                >
                  <p>選擇出生地</p>
                  <span
                    className="input-block"
                    style={{
                      marginLeft: "2.5rem",
                      fontSize: "1.1rem",
                      color: birthPlaceName
                        ? undefined
                        : "rgba(198, 198, 198)",
                    }}
                  >
                    {birthPlaceName || "請選擇"}
                  </span>
                  <img src="../images/ic-brown-down.png"></img>
                </div>
              )}

              {timeMode == "1" && (
                <div
                  style={{
                    fontSize: "0.8rem",
                    marginBottom: "0.5rem",
                    color: "rgb(108, 49, 57)",
                  }}
                >
                  * 選擇出生地後，將自動帶入該地經緯度
                </div>
              )}

              <div
                className={`born-place ${timeMode == "1" ? "showBlock" : "hideBlock"}`}
              >
                <div
                  className={`item-info place ${foucsIndex == 5 ? "foucs" : "non-focus"}`}
                  onClick={(e) => {
                    setShowSunTimeDes(false);
                    setShowGenderMenu(false);
                    e.stopPropagation();
                  }}
                >
                  <p>出生地-經度</p>

                  <input
                    type="number"
                    className="input-block"
                    min="-180"
                    max="180"
                    step="any" //允許小數
                    inputMode="decimal" //手機顯示小數鍵盤
                    placeholder="請輸入經度"
                    value={birthLongitude}
                    onChange={(e) => {
                      setBirthLongitude(e.target.value);
                    }}
                    onFocus={() => {
                      setFoucsIndex(5);
                    }}
                  ></input>
                </div>

                <div className="space"></div>

                <div
                  className={`item-info place ${foucsIndex == 6 ? "foucs" : "non-focus"}`}
                  onClick={(e) => {
                    setShowSunTimeDes(false);
                    setShowGenderMenu(false);
                    e.stopPropagation();
                  }}
                >
                  <p>出生地-緯度</p>

                  <input
                    className="input-block"
                    type="number"
                    step="any"
                    inputMode="decimal"
                    placeholder="請輸入緯度"
                    min="-90"
                    max="90"
                    value={birthLatitude}
                    onChange={(e) => {
                      setBirthLatitude(e.target.value);
                    }}
                    onFocus={() => {
                      setFoucsIndex(6);
                    }}
                  ></input>
                </div>
              </div>
            </div>

            <button
              className={`${isFormComplete ? "active" : "disabled"}`}
              disabled={!isFormComplete}
              onClick={() => {
                handleRegister();
              }}
            >
              立即完成註冊
            </button>
          </div>
        </main>
      )}

      {isMobile && (
        <main
          className="mobile-main"
          onMouseEnter={() => {
            setShowServiceMenu(false);
            setShowPersonalMenu(false);
          }}
          onClick={() => {
            setShowBirthTimeMenu(false);
            setShowGenderMenu(false);
            setShowSunTimeDes(false);
          }}
        >
          <div className="input-background">
            <img
              src={`/images/bg-input-info.png`}
              loading="lazy"
              alt="圖片 1"
            />
          </div>

          <p className="title">開始探索元辰雲閣</p>
          <p className="sub-title">
            請輸入您的個人資訊，資料越詳細結果越準確哦！
          </p>

          {/*註冊資訊輸入卡*/}
          <div className="user-card">
            {/*你的姓名*/}
            <div
              className={`item-info ${foucsIndex == 0 ? "foucs" : "non-focus"}`}
            >
              <p>你的姓名</p>
              <input
                className="input-block"
                placeholder="請輸入姓名"
                maxLength={10}
                value={name}
                onChange={(e) => setName(e.target.value)}
                onFocus={() => {
                  setFoucsIndex(0);
                }}
              ></input>
            </div>

            {/*性別選單*/}
            <div
              className={`item-info menu ${foucsIndex == 1 ? "foucs" : "non-focus"}`}
              onClick={(e) => {
                e.stopPropagation();
                setShowBirthTimeMenu(false);
                setShowSunTimeDes(false);
                setShowGenderMenu(!showGenderMenu);
              }}
            >
              <p>性別</p>
              <input
                className="input-block"
                placeholder="請選擇生理性別"
                readOnly
                value={GENDER_MAP[gender] || ""}
                onFocus={() => {
                  setFoucsIndex(1);
                }}
              ></input>
              <img src="../images/ic-brown-down.png"></img>
              {showGenderMenu && (
                <div className="float-menu">
                  <GenderMenu
                    dataMap={GENDER_MAP}
                    onSuccess={(gender) => {
                      setGender(gender);
                    }}
                    onClose={() => setShowGenderMenu(false)}
                  ></GenderMenu>
                </div>
              )}
            </div>

            {/*出生日期日曆*/}
            <div
              className={`item-info  ${foucsIndex == 2 ? "foucs" : "non-focus"}`}
            >
              <p>出生日期</p>
              <div className="calender">
                <CalenderPicker
                  birthDate={birthDate}
                  setBirthDate={setBirthDate}
                  onFocus={() => {
                    setFoucsIndex(2);
                  }}
                />
              </div>
              <img src="../images/ic-brown-down.png"></img>
            </div>

            {/*標準時間／太陽時選擇*/}
            <div className="select-radio">
              <div className="option">
                <input
                  type="radio"
                  name="mobile-method"
                  id="mobile-standard"
                  value="standard"
                  checked={timeMode === "0"}
                  onChange={() => setTimeMode("0")}
                />
                <label htmlFor="mobile-standard">標準時間</label>
              </div>

              <div className="option suntime">
                <input
                  type="radio"
                  name="mobile-method"
                  id="mobile-sun"
                  value="sun"
                  checked={timeMode === "1"}
                  onChange={() => setTimeMode("1")}
                />
                <label htmlFor="mobile-sun">真太陽時</label>

                <img
                  onClick={(e) => {
                    setShowGenderMenu(false);
                    setShowBirthTimeMenu(false);
                    setShowSunTimeDes(true);
                    e.stopPropagation();
                  }}
                  src="../images/ic-description.png"
                ></img>

                <div className="suntime-tag">
                  {showSunTimeDes && (
                    <div
                      className="suntime-des"
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <p className="title">什麼是真太陽時？</p>
                      <p className="des">
                        真太陽時（True Solar Time）是以天文學算式計算太陽
                        相對地平線的位置的時間，反映某地實際日照狀況。當
                        太陽位於當地子午線上時，即為「真正的中午」。它不同
                        於人為劃分的標準時間，因為地球自轉與公轉的影響，真
                        太陽時會因地點與日期而有所變化，真太陽時則能根據
                        個人的出生經緯度，精確地還原當地的實際時間。
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/*出生時辰-標準時間選單*/}
            {timeMode == "0" && (
              <div
                className={`item-info menu ${foucsIndex == 3 ? "foucs" : "non-focus"}`}
                onClick={(e) => {
                  setShowSunTimeDes(false);
                  setShowGenderMenu(false);
                  setShowBirthTimeMenu(!showBirthTimeMenu);
                  e.stopPropagation();
                }}
              >
                <p>出生時辰</p>
                <input
                  className="input-block"
                  placeholder="早子時 00:00-00:59"
                  value={BIRTH_TIME_MAP[birthTimeSign] || ""}
                  readOnly
                  onFocus={() => {
                    setFoucsIndex(3);
                  }}
                ></input>
                <img src="../images/ic-brown-down.png"></img>
                {showBirthTimeMenu && (
                  <div className="float-menu">
                    <BirthTimeMenu
                      dataMap={BIRTH_TIME_MAP}
                      onSuccess={(timeSign) => {
                        setBirthTimeSign(timeSign);
                      }}
                      onClose={() => setShowBirthTimeMenu(false)}
                    ></BirthTimeMenu>
                  </div>
                )}
              </div>
            )}

            {/*出生時辰-真太陽時選單*/}
            {timeMode == "1" && (
              <div>
                <div
                  className={`item-info menu ${foucsIndex == 4 ? "foucs" : "non-focus"}`}
                  onClick={(e) => {
                    setShowSunTimeDes(false);
                    setShowGenderMenu(false);
                    e.stopPropagation();
                  }}
                >
                  <p>出生時辰</p>

                  <ClockPicker
                    clockTime={birthClockTime}
                    setClockTime={setBirthClockTime}
                    onFocus={() => {
                      setFoucsIndex(4);
                    }}
                  />

                  <img src="../images/ic-brown-down.png"></img>
                </div>

                {/*快速選擇出生地：自己一格，跟出生時辰同層；選好自動填入下方經緯度*/}
                <div
                  className={`item-info menu ${foucsIndex == 7 ? "foucs" : "non-focus"}`}
                  onClick={(e) => {
                    setShowSunTimeDes(false);
                    setShowGenderMenu(false);
                    setFoucsIndex(7);
                    setShowBirthplacePicker(true);
                    e.stopPropagation();
                  }}
                >
                  <p>選擇出生地</p>
                  <span
                    className="input-block"
                    style={{
                      marginLeft: "1rem",
                      fontSize: "0.85rem",
                      color: birthPlaceName
                        ? undefined
                        : "rgba(198, 198, 198)",
                    }}
                  >
                    {birthPlaceName || "請選擇"}
                  </span>
                  <img src="../images/ic-brown-down.png"></img>
                </div>

                <div
                  style={{
                    fontSize: "0.8rem",
                    marginBottom: "0.5rem",
                    color: "rgb(108, 49, 57)",
                  }}
                >
                  * 選擇出生地後，將自動帶入該地經緯度
                </div>

                <div
                  className={`born-place ${timeMode == "1" ? "showBlock" : "hideBlock"}`}
                >
                  <div
                    className={`item-info place ${foucsIndex == 5 ? "foucs" : "non-focus"}`}
                    onClick={(e) => {
                      setShowSunTimeDes(false);
                      setShowGenderMenu(false);
                      e.stopPropagation();
                    }}
                  >
                    <p>出生地-經度</p>

                    <input
                      type="number"
                      className="input-block"
                      min="-180"
                      max="180"
                      step="any"
                      inputMode="decimal"
                      placeholder="請輸入經度"
                      value={birthLongitude}
                      onChange={(e) => {
                        setBirthLongitude(e.target.value);
                      }}
                      onFocus={() => {
                        setFoucsIndex(5);
                      }}
                    ></input>
                  </div>

                  <div className="space"></div>

                  <div
                    className={`item-info place ${foucsIndex == 6 ? "foucs" : "non-focus"}`}
                    onClick={(e) => {
                      setShowSunTimeDes(false);
                      setShowGenderMenu(false);
                      e.stopPropagation();
                    }}
                  >
                    <p>出生地-緯度</p>

                    <input
                      className="input-block"
                      type="number"
                      step="any"
                      inputMode="decimal"
                      placeholder="請輸入緯度"
                      min="-90"
                      max="90"
                      value={birthLatitude}
                      onChange={(e) => {
                        setBirthLatitude(e.target.value);
                      }}
                      onFocus={() => {
                        setFoucsIndex(6);
                      }}
                    ></input>
                  </div>
                </div>
              </div>
            )}

            <button
              className={`${isFormComplete ? "active" : "disabled"}`}
              disabled={!isFormComplete}
              onClick={() => {
                handleRegister();
              }}
            >
              立即完成註冊
            </button>
          </div>
        </main>
      )}

      {/*隱私政策與聯絡官方*/}
      <SiteFooter />

      {/* 註冊成功 toast — 自動 1 秒關閉，關閉時跳回原頁（state.from）或個人命盤 */}
      <ToastDialog
        open={showRegisterSuccess}
        onClose={() => {
          setShowRegisterSuccess(false);
          navigate(returnTo);
        }}
        message="註冊成功"
      />

      {/* 出生地級聯選擇（真太陽時模式下用） */}
      <BirthplacePicker
        open={showBirthplacePicker}
        onClose={() => setShowBirthplacePicker(false)}
        onSelect={handleBirthplaceSelect}
      />
    </div>
  );
};

export default RegisterComponent;
